import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { Loading } from 'components/atoms/loading';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { useAccountDataQuery } from 'queries/account';
import { lazyWithRetry } from 'utils/lazyWithRetry';
import { NotFound } from '../404';
import { SecureRoute } from '../route-with-permission-check';
import { ROUTE_PATHS } from '../routes-paths';
const MigrationAgentsIndexPage = lazyWithRetry(()=>import('components/pages/migration-agents/migration-agents-index-page').then(({ MigrationAgentsIndexPage: Component })=>({
            default: Component
        })));
function MigrationAgentFeatureGate({ children }) {
    const { isLoading } = useAccountDataQuery();
    const [isMigrationAgentEnabled] = useAccountFeature(AccountFeature.MigrationAgent);
    if (isLoading) {
        return /*#__PURE__*/ _jsx(Loading, {});
    }
    if (!isMigrationAgentEnabled) {
        return /*#__PURE__*/ _jsx(NotFound, {});
    }
    return children;
}
export const migrationAgentsRoutes = [
    {
        path: ROUTE_PATHS.MIGRATION_AGENTS,
        element: /*#__PURE__*/ _jsx(SecureRoute, {
            children: /*#__PURE__*/ _jsx(MigrationAgentFeatureGate, {
                children: /*#__PURE__*/ _jsx(Suspense, {
                    fallback: /*#__PURE__*/ _jsx(Loading, {}),
                    children: /*#__PURE__*/ _jsx(MigrationAgentsIndexPage, {})
                })
            })
        })
    }
];
